import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-av-dialogue-box',
  templateUrl: './av-dialogue-box.component.html',
  styleUrls: ['./av-dialogue-box.component.scss']
})
export class AvDialogueBoxComponent implements OnInit {
  layoutConf: any;
  @Output() closeDlg: EventEmitter<any> = new EventEmitter();
  @Output() saveData: EventEmitter<any> = new EventEmitter();
  @Input() title: string;
  @Input() isDisable: boolean = false;
  @Input() action: string;
  @Input() closeText: string;
  constructor( ) {
    this.action = 'SAVE'
    this.closeText = 'EXIT'
  }

  ngOnInit(): void { }

  closeDialogue() {
    this.closeDlg.emit();
  }

  save() {
    this.saveData.emit();
  }
}
